<template>
  <h3>Editar Publicidade</h3>
  <form ref="form" @submit.prevent="submitForm">
    <div v-for="field in fields" :key="field.key" class="row">
      <div v-if="field.type === 'select'" class="col-md-12">
        <label :for="field.key">{{ field.label }}</label>
        <br />
        <select v-model="registro[field.key]" class="ant-select ant-select-lg custom-select">
          <option v-for="option in field.options" :key="option.value" :value="option.value">{{ option.label }}</option>
        </select>
      </div>
      <div v-else-if="field.type === 'file'" class="col-md-12">
        <label :for="field.key">{{ field.label }}</label>
        <br />
        <input ref="file" :type="field.type" class="ant-input ant-input-lg" />
        <br />
        <template v-if="registro.idArquivo">
          <a :href="createArquivoURLPublica(registro.idArquivo)" target="_blank">Clique para visualizar o arquivo anterior</a>
        </template>
        <template v-else> Não há arquivo associado a este registro </template>
      </div>
      <div v-else-if="field.type === 'date'" class="col-md-12">
        <label :for="field.key">{{ field.label }}</label>
        <br />
        <input :ref="field.key" :value="stringDataInternacional(registro[field.key])" type="date" class="ant-input ant-input-lg" />
      </div>
      <div v-else class="col-md-12">
        <label :for="field.key">{{ field.label }}</label>
        <br />
        <input v-model="registro[field.key]" :type="field.type" class="ant-input ant-input-lg" />
      </div>
    </div>
    <div class="spaced-container2">
      <a-button class="yellow-button" @click="voltar"> Voltar </a-button>
      <button type="submit" class="ant-btn ant-btn-primary" @click="salvar">Salvar</button>
    </div>
  </form>
</template>

<script>
import { createPublicidade } from '@/components/service/publicidadeService';
import { sendDocumentFileWs } from '@/utils/filews';
import { openNotification, typesNotification } from '@/utils/notifications';
import { getPublicidadeById } from '@/components/service/publicidadeService';
import { createArquivoURLPublica } from '@/utils/filews';

export default {
  name: 'FormEditarPublicidade',
  data() {
    return {
      registro: {},
      registroInicial: {},
      fields: [
        { key: 'nome', label: 'Nome', type: 'text' },
        {
          key: 'tipo',
          label: 'Tipo',
          type: 'select',
          options: [
            { label: 'Vídeo', value: 'VIDEO' },
            { label: 'Banner', value: 'BANNER' },
          ],
        },
        { key: 'idArquivo', label: 'Arquivo', type: 'file' },
        { key: 'dataInicio', label: 'Data Início', type: 'date' },
        { key: 'dataFim', label: 'Data Fim', type: 'date' },
        {
          key: 'situacao',
          label: 'Status',
          type: 'select',
          options: [
            { label: 'Ativo', value: 'ATIVO' },
            { label: 'Inativo', value: 'INATIVO' },
          ],
        },
      ],
    };
  },
  methods: {
    async salvar() {
      const ini = new Date(this.$refs.dataInicio[0].value);
      const fim = new Date(this.$refs.dataFim[0].value);
      console.log(ini);
      console.log(fim);
      const arquivoModificado = this.$refs.file[0].files[0];
      let idArquivo = this.registro.idArquivo;
      if (arquivoModificado) {
        const resArquivo = await sendDocumentFileWs(arquivoModificado, 'PUBLICO', 'ssp');
        idArquivo = resArquivo.data.id;
      }

      this.registro.id = this.$route.query.id;
      this.registro.idArquivo = idArquivo;
      this.registro.dataInicio = ini.setUTCHours(ini.getUTCHours() + 3);
      this.registro.dataFim = fim.setUTCHours(fim.getUTCHours() + 3);
      await createPublicidade(this.registro);
      this.voltar();
      openNotification(typesNotification.success, 'Publicidade atualizada com sucesso');
    },
    voltar() {
      this.$router.go(-1);
    },
    stringDataInternacional(dataStr) {
      if (!dataStr) {
        return null;
      }
      const date = new Date(dataStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async carregarPublicidade() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getPublicidadeById(idUrl);
        // const urlArquivo = createArquivoURLPublica(res.data.idArquivo)

        this.registroInicial = { ...res.data, id: idUrl };
        this.registro = { ...res.data, id: idUrl };
      }
    },
    createArquivoURLPublica,
  },
  created() {
    this.carregarPublicidade();
  },
};
</script>

<style scoped>
.yellow-button {
  background-color: #faad14;
  border-color: #faad14;
  color: white;
  margin-top: 10px;
}

.yellow-button:hover {
  background-color: #ffc53d;
  border-color: #ffc53d;
  color: white;
}
.spaced-container2 * {
  margin-top: 10px;
  margin-right: 10px;
}
.custom-select {
  width: 100%;
  height: 40px;
  font-size: 16px;
  padding: 8px 12px;
}
</style>
